var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMakeup3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.25 12C20.25 11.0172 20.0782 10.0746 19.7629 9.20052L21.1048 7.85859C21.6797 9.12049 22 10.5228 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C13.4771 2 14.8794 2.32026 16.1413 2.89514L14.7994 4.23707C13.9253 3.92182 12.9827 3.75 12 3.75C7.44365 3.75 3.75 7.44365 3.75 12C3.75 16.5563 7.44365 20.25 12 20.25C16.5563 20.25 20.25 16.5563 20.25 12Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5601 10.4034L18.2076 10.7558L16.5101 14.5832C15.9179 15.9184 14.2167 16.5457 12.8897 15.6351C11.1151 14.4173 9.58265 12.8849 8.36481 11.1102C7.45417 9.78321 8.08152 8.08205 9.41674 7.48985L13.2441 5.79231L13.5965 5.43992C13.0847 5.31579 12.55 5.25 12 5.25C8.27208 5.25 5.25 8.27208 5.25 12C5.25 15.7279 8.27208 18.75 12 18.75C15.7279 18.75 18.75 15.7279 18.75 12C18.75 11.4499 18.6842 10.9152 18.5601 10.4034Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1074 7.05033L16.9496 9.89249L15.1389 13.975C14.8967 14.5211 14.231 14.7364 13.7384 14.3984C12.1159 13.2849 10.715 11.8841 9.6016 10.2616C9.49595 10.1076 9.44435 9.93674 9.44 9.76719C9.43872 9.71723 9.44153 9.66738 9.44828 9.61811C9.4919 9.29958 9.69975 9.00525 10.0249 8.86103L14.1074 7.05033Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0319 6.12602L17.8741 8.96819L21.3733 5.46895C22.1877 4.65458 22.2116 3.35816 21.4268 2.57332C20.6419 1.78848 19.3455 1.81242 18.5312 2.62678L15.0319 6.12602Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMakeup3);
export default __webpack_public_path__ + "static/media/makeup-3.ec711beb009e36efcb54d6f9b070f799.svg";
export { ForwardRef as ReactComponent };